import { globals } from "@client/globals";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import User, { type UserProps } from "@client/widgets/User/component";

const mapStateToProps = (state: AppState): UserProps => {
  return {
    canRegister: true,
    profilePageId: globals.siteInfo.profilePageId,
    registerPageId: globals.siteInfo.registerPageId
  };
};

export default connectCustom(mapStateToProps)(User);
